// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

export enum ChartNoteStatus {
  Unsigned = 'unsigned',
  Signed = 'signed',
  SignedAndLocked = 'signedAndLocked',
}
